"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description Планировщик задач.
 * Принимает на вход задачу <job> и выполняет ее раз в <interval> миллисекунд.
 */
var Scheduler = /** @class */ (function () {
    function Scheduler(_a) {
        var interval = _a.interval, job = _a.job;
        this.interval = interval;
        this.intervalId = null;
        this.job = job;
    }
    Scheduler.prototype.start = function () {
        if (this.running) {
            return;
        }
        this.running = true;
        this.intervalId = window.setInterval(this.job, this.interval);
    };
    Scheduler.prototype.stop = function () {
        if (!this.running) {
            return;
        }
        this.running = false;
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    };
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=scheduler.js.map